import { render, staticRenderFns } from "./sectionTitle.vue?vue&type=template&id=072dca6a&scoped=true"
import script from "./sectionTitle.vue?vue&type=script&lang=js"
export * from "./sectionTitle.vue?vue&type=script&lang=js"
import style0 from "./sectionTitle.vue?vue&type=style&index=0&id=072dca6a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072dca6a",
  null
  
)

export default component.exports